export default "__VITE_ASSET__Bc6ZQVd3__"